import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import { logout } from '../../redux/features/userSlice'
import { useDispatch } from 'react-redux';

function Sidebar() {
	const dispatch = useDispatch();
  return (
    <div class="col-xl-3">
				{/* <!-- Responsive offcanvas body START --> */}
				<div class="offcanvas-xl offcanvas-end" tabIndex="-1" id="offcanvasSidebar" aria-labelledby="offcanvasSidebarLabel">
					{/* <!-- Offcanvas header --> */}
					<div class="offcanvas-header bg-light">
						<h5 class="offcanvas-title" id="offcanvasNavbarLabel">لوحة التحكم</h5>
						<button  type="button" class="btn-close" data-bs-dismiss="offcanvas" data-bs-target="#offcanvasSidebar" aria-label="Close"></button>
					</div>
					{/* <!-- Offcanvas body --> */}
					<div class="offcanvas-body p-3 p-xl-0">
						<div class="bg-dark border rounded-3 pb-0 p-3 w-100">
							{/* <!-- Dashboard menu --> */}
							<div class="list-group list-group-dark list-group-borderless">
								<NavLink class="nav-link" to='/user-dashboard' end>
                  {({ isActive, isPending }) => (
                      <li className={isActive ? "list-group-item active" : "list-group-item"} data-bs-dismiss="offcanvas" data-bs-target="#offcanvasSidebar">
                        <i class="bi bi-ui-checks-grid fa-fw me-2"></i>طلباتي
                      </li>
                    )}
								</NavLink>

								<NavLink class="nav-link" to='/user-dashboard/verify-account'>
									{({ isActive, isPending }) => (
										<li className={isActive ? "list-group-item active" : "list-group-item"} data-bs-dismiss="offcanvas" data-bs-target="#offcanvasSidebar">
											<i class="bi bi-patch-check fa-fw me-2"></i>توثيق الحساب
										</li>
										)}
								</NavLink>
								<NavLink class="nav-link" to='/user-dashboard/create-request'>
									{({ isActive, isPending }) => (
										<li className={isActive ? "list-group-item active" : "list-group-item"} data-bs-dismiss="offcanvas" data-bs-target="#offcanvasSidebar">
											<i class="bi bi-file-earmark-plus fa-fw me-2"></i>تقديم عريضة
										</li>
										)}
								</NavLink>
								<NavLink class="nav-link" to='/user-dashboard/general-info'>
									{({ isActive, isPending }) => (
										<li className={isActive ? "list-group-item active" : "list-group-item"} data-bs-dismiss="offcanvas" data-bs-target="#offcanvasSidebar">
											<i class="bi bi-person-rolodex fa-fw me-2"></i>الملف الشخصي
										</li>
										)}
								</NavLink>



								<NavLink class="nav-link" to='/user-dashboard/update-password'>
                  {({ isActive, isPending }) => (
                      <li className={isActive ? "list-group-item active" : "list-group-item"} data-bs-dismiss="offcanvas" data-bs-target="#offcanvasSidebar">
                        <i class="bi bi-key fa-fw me-2"></i>تحديث كلمة المرور
                      </li>
                    )}
								</NavLink>


        
								<li role='button' onClick={()=> dispatch(logout())}  class="list-group-item text-danger bg-danger-soft-hover"><i class="fas fa-sign-out-alt fa-fw me-2"></i>تسجيل الخروج</li>
							</div>
						</div>
					</div>
				</div>
				{/* <!-- Responsive offcanvas body END --> */}
			</div>
  )
}

export default Sidebar